// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".steps[data-v-4254d9a6]{display:flex}.step[data-v-4254d9a6],.steps[data-v-4254d9a6]{margin:0!important}.step[data-v-4254d9a6]{background:#d6d6d6;border-radius:10rem;display:inline-block;height:.2rem;width:3.33rem}.step[data-v-4254d9a6]:not(:last-child){margin-right:.33rem!important}.step.reached[data-v-4254d9a6]{background:#23b573}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
